var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var VectorAutoRegressiveForecastConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { BeforeDeserialized, JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ForecastFrequency } from './baseForecastConfig';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolValidationState } from './validation/toolValidationResult';
import { isSourceValid } from './validation/validateHelper';
import { vectorAutoRegressiveForecastConfigSchemaValidation } from '../validations.generated';
export const vectorAutoRegressiveForecastConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:VectorAutoRegressiveForecastConfig',
    type: 'object',
    properties: {
        dateColumn: { type: 'string', minLength: 1 },
        valueColumns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true, minItems: 2 },
        aliases: {
            type: 'array',
            items: { type: 'string', minLength: 1 },
            uniqueItems: true,
            minItems: { $data: '1/valueColumns/length' },
            maxItems: { $data: '1/valueColumns/length' }
        },
        periods: { type: 'integer', minimum: 1 },
        frequency: {
            type: 'string',
            enum: Object.values(ForecastFrequency)
        },
        groupByColumns: {
            type: 'array',
            items: { type: 'string' },
            uniqueItems: true
        },
        uncertainty: { type: 'boolean' }
    },
    required: ['dateColumn', 'valueColumns', 'aliases', 'periods']
};
let VectorAutoRegressiveForecastConfig = VectorAutoRegressiveForecastConfig_1 = class VectorAutoRegressiveForecastConfig extends ToolConfig {
    constructor(dateColumn, valueColumns, aliases, periods, frequency, groupByColumns, customFormats) {
        super(ToolType.VECTOR_AUTO_REGRESSIVE_FORECAST, customFormats);
        this.dateColumn = dateColumn;
        this.valueColumns = valueColumns;
        this.aliases = aliases;
        this.periods = periods;
        this.frequency = frequency;
        if (groupByColumns !== undefined)
            this.groupByColumns = groupByColumns;
        this.uncertainty = true;
        JSON.validate(this, VectorAutoRegressiveForecastConfig_1);
    }
    setDefaults() {
        this.frequency = ForecastFrequency.BestGuess;
        this.uncertainty = false; // forecast created in old time should have this as False
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return this.ins[0];
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return VectorAutoRegressiveForecastConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return VectorAutoRegressiveForecastConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return VectorAutoRegressiveForecastConfig_1.outs;
    }
    static get in() {
        return VectorAutoRegressiveForecastConfig_1.ins[0];
    }
    static get out() {
        return VectorAutoRegressiveForecastConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.VECTOR_AUTO_REGRESSIVE_FORECAST.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.UNSEEN, ToolCategories.FORECAST], this.ins, this.outs, ['vector auto regressive', 'var', 'auto regressive', 'ar', 'forecast'], false);
    }
    getOutput(iConfigHelper, ins) {
        return this.getOutputForForecastConfig(ins, this.in, this.out, this.dateColumn, this.valueColumns, this.aliases, this.uncertainty, this.groupByColumns);
    }
    isValidForCalc(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationState.BAD_METADATA;
        }
        const newAddedCols = ['IsForecast'];
        if (this.uncertainty) {
            this.aliases.forEach((x) => {
                newAddedCols.push(`${x} Lower`);
                newAddedCols.push(`${x} Upper`);
            });
        }
        const outputs = this.groupByColumns ? [...this.groupByColumns, ...newAddedCols] : [...newAddedCols];
        outputs.push(this.dateColumn, ...this.valueColumns, ...this.aliases);
        if (new Set(outputs).size !== outputs.length) {
            return ToolValidationState.BAD_METADATA;
        }
        const inputs = new Map([[this.dateColumn, ['date']]]);
        this.valueColumns.forEach((x) => {
            inputs[x] = `${x} Lower`;
            inputs[x] = `${x} Upper`;
        });
        this.addGroupByToInputs(inputs, this.groupByColumns);
        return isSourceValid(source, inputs, []) ? ToolValidationState.VALID : ToolValidationState.BAD_METADATA;
    }
};
__decorate([
    BeforeDeserialized()
], VectorAutoRegressiveForecastConfig.prototype, "setDefaults", null);
VectorAutoRegressiveForecastConfig = VectorAutoRegressiveForecastConfig_1 = __decorate([
    JsonSchemaV2(vectorAutoRegressiveForecastConfigSchema, vectorAutoRegressiveForecastConfigSchemaValidation),
    JsonDiscriminatorValue(ToolType.VECTOR_AUTO_REGRESSIVE_FORECAST)
], VectorAutoRegressiveForecastConfig);
export { VectorAutoRegressiveForecastConfig };
//# sourceMappingURL=vectorAutoRegressiveForecastConfig.js.map